/**
 * @file Confirm user email container.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import { emailVerify } from '../../graphql/mutations/account';
import { MeQuery } from '../../graphql/queries/account';
import { cleanApolloError } from '../../util/normalize-errors';
import Alert from '../../components/global/Alert';
import { getAsset } from '../../util/assets';

class EmailVerify extends Component {
  static propTypes = {
    verifyEmail: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    user: PropTypes.shape({
      id: PropTypes.string,
      email_verified: PropTypes.bool,
    }).isRequired,
  };

  state = {
    error: '',
    success: '',
  };

  /* eslint-disable react/no-did-mount-set-state */
  async componentDidMount() {
    const { user, verifyEmail, history } = this.props;
    const token = this.getTokenFromUrl();
    const redirectUrl = this.getRedirectUrl();

    // Redirect the user if they're already verified
    if (user.email_verified) {
      history.replace(redirectUrl);
      return;
    }

    if (!token) {
      this.setState(() => ({
        error:
          'No verification token found, ' +
          'please make sure you clicked the right link.',
      }));
      return;
    }

    try {
      await verifyEmail(user.id, token);
      this.setState(() => ({
        success: 'Your email has been verified! Redirecting you!',
      }));

      setTimeout(() => history.replace(redirectUrl), 1500);
    } catch ({ message }) {
      this.setState(() => ({ error: cleanApolloError(message) }));
    }
  }

  getTokenFromUrl() {
    const parsed = qs.parse(this.props.location.search);
    return parsed.token;
  }

  getRedirectUrl = () => {
    const parsed = qs.parse(this.props.location.search);
    return parsed.next || '/app';
  };

  render() {
    const { error, success } = this.state;

    return (
      <div className="text-center">
        <img
          src={getAsset('/waldo-icon.svg')}
          width="36"
          alt="Waldo"
          className="mb-1"
        />
        <h4 className="m-0">Verifying your email...</h4>

        {error && (
          <Alert type="danger" className="mt-2">
            {error}
          </Alert>
        )}
        {success && (
          <Alert type="success" className="mt-2">
            {success}
          </Alert>
        )}
      </div>
    );
  }
}

const withEmailVerifyMutation = graphql(emailVerify, {
  props: ({ mutate }) => ({
    verifyEmail: (accountId, token) =>
      mutate({
        variables: {
          input: { account_id: accountId, token },
        },
      }),
  }),
});

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
});

export { EmailVerify };

export default compose(
  withEmailVerifyMutation,
  withUserData,
  withRouter,
)(({ user, ...props }) => {
  return user ? <EmailVerify user={user} {...props} /> : null;
});
